export default {
  getPallet: (state) => state.pallet,
};
